@if (!editMode) {
  <h2 mat-dialog-title>[NEU] Modul Vektorgraphik hinzufügen</h2>
}
@if (editMode) {
  <h2 mat-dialog-title>[NEU] Modul Vektorgraphik editieren</h2>
}
<mat-dialog-content>
  <div>
    <form
      [formGroup]="orthofotoForm"
      (ngSubmit)="updateOrCreateModule()"
      ngNativeValidate
      class="d-flex flex-column"
      >
      <!-- <pre>Form values: {{ orthofotoForm?.value | json }}</pre> -->

      <h5 class="">Allgemeine Konfiguration</h5>
      <mat-form-field>
        <mat-label>Überschrift</mat-label>
        <input matInput formControlName="headline" required />
        @if (orthofotoForm.controls.headline.hasError('required')) {
          <mat-error>
            Überschrift angeben
          </mat-error>
        }
      </mat-form-field>

      <mat-slide-toggle formControlName="timePeriodFiltered"
        >{{ "app.filterTimePeriod" | translate }}</mat-slide-toggle
        >

        <mat-form-field>
          <mat-label>Startzeit</mat-label>
          <input
            [attr.disabled]="timeFilterDisabled"
            matInput
            formControlName="timePeriodFilteredFrom"
            />
          @if (
            orthofotoForm.controls.timePeriodFilteredFrom.hasError('validTime')
            ) {
            <mat-error
              >
              Zeitraum im Format [hh:mm] angeben
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Endzeit</mat-label>
          <input
            [attr.disabled]="timeFilterDisabled"
            matInput
            formControlName="timePeriodFilteredTill"
            />
          @if (
            orthofotoForm.controls.timePeriodFilteredTill.hasError('validTime')
            ) {
            <mat-error
              >
              Zeitraum im Format [hh:mm] angeben
            </mat-error>
          }
        </mat-form-field>

        <h5 class="mt-4">Datenquellen</h5>
        <mat-checkbox class="mb-2" formControlName="allDatasourcesChecked">
          Alle auswählen
        </mat-checkbox>
        <div class="list-group">
          <ng-container formArrayName="datasources">
            @for (datasource of availableDataSources; track datasource; let i = $index) {
              <div
                class="list-group-item"
                [formGroupName]="i"
                >
                <mat-checkbox formControlName="checked">
                  {{ datasource.display_name }}
                </mat-checkbox>
              </div>
            }
          </ng-container>
        </div>

        <h5 class="mt-12">Definition Farben</h5>

        <mat-form-field>
          <mat-label>Zeitraum für Farbänderung Sensor ohne Messung</mat-label>
          <input type="number" matInput formControlName="differenceHours" />
        </mat-form-field>
        <p class="mb-2">
          <a target="_blank" href="https://html-color-codes.info/color-names/"
            >Valide HTML Farbe
            <mat-icon inline="true"> arrow_outward </mat-icon></a
            >
            oder
            <a target="_blank" href="https://html-color-codes.info/"
              >HEX Code <mat-icon inline="true"> arrow_outward </mat-icon></a
              >
            </p>
            <mat-form-field>
              <mat-label>Farbe Messwerte aktuell</mat-label>
              <input matInput formControlName="colorOk" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Farbe Sensor ohne Messung</mat-label>
              <input matInput formControlName="colorWarning" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ "app.colorDisplacementHeight" | translate }}</mat-label>
              <input matInput formControlName="colorHeightVector" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ "app.colorDisplacement2D" | translate }}</mat-label>
              <input matInput formControlName="color2dVector" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>Skalierungsfaktor Maßstab [%]</mat-label>
              <input matInput formControlName="scaleSizeFactor" type="number" />
              <span matSuffix>%</span>
            </mat-form-field>

            <h5 class="mt-4">Bahnachsen</h5>
            <div class="user-selection-group">
              @for (axis of axisFromFormGroup().controls; track axis) {
                <div
                  class="row row-cols-1 row-cols-sm-2"
                  [formGroup]="axis"
                  >
                  <!-- X1 -->
                  <mat-form-field class="col">
                    <mat-label>Rechtswert 1</mat-label>
                    <input matInput formControlName="x1" />
                    @if (axis.get('x1').hasError('required')) {
                      <mat-error>
                        Feld wird benötigt
                      </mat-error>
                    }
                  </mat-form-field>
                  <!-- Y1 -->
                  <mat-form-field class="col">
                    <mat-label>Hochwert 1</mat-label>
                    <input matInput formControlName="y1" />
                    @if (axis.get('y1').hasError('required')) {
                      <mat-error>
                        Feld wird benötigt
                      </mat-error>
                    }
                  </mat-form-field>
                  <!-- X2 -->
                  <mat-form-field class="col">
                    <mat-label>Rechtswert 2</mat-label>
                    <input matInput formControlName="x2" />
                    @if (axis.get('x2').hasError('required')) {
                      <mat-error>
                        Feld wird benötigt
                      </mat-error>
                    }
                  </mat-form-field>
                  <!-- Y2 -->
                  <mat-form-field class="col">
                    <mat-label>Hochwert 2</mat-label>
                    <input matInput formControlName="y2" />
                    @if (axis.get('y2').hasError('required')) {
                      <mat-error>
                        Feld wird benötigt
                      </mat-error>
                    }
                  </mat-form-field>
                  <!-- Bahnachse Text -->
                  <mat-form-field class="col">
                    <mat-label>Anzeigetext</mat-label>
                    <input matInput formControlName="text" type="text" />
                    @if (axis.get('text').hasError('required')) {
                      <mat-error>
                        Feld wird benötigt
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              }

              <div class="row justify-content-center">
                <button mat-mini-fab (click)="addAxis($event)">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>

            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="!orthofotoForm.valid || submitting"
              >
              @if (editMode) {
                Speichern
              }
              @if (!editMode) {
                Hinzufügen
              }
            </button>
          </form>
        </div>
      </mat-dialog-content>
